import { ReactElement } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid';

import DataGridBlankLabel from '../../../ui/datagrid/datagrid-blank-label';
import { IColumnAction } from '../../../../interfaces/datagrid.interface';

export const columns: IColumnAction[] = [
  {
    field: 'code',
    headerName: 'Employee Code',
    width: 150,
    disableColumnMenu: true,
    renderCell: (e: GridRenderCellParams): ReactElement => {
      return DataGridBlankLabel(e.row.code || e.row.application.code);
    },
  },
  {
    field: 'fullname',
    headerName: 'Name',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e: GridRenderCellParams): ReactElement => {
      return DataGridBlankLabel(e.row.fullname || e.row.application.fullname);
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 180,
    disableColumnMenu: true,
    renderCell: (e: GridRenderCellParams): ReactElement => {
      return DataGridBlankLabel(e.row.status);
    },
  },
];
